import React from 'react';
import { Dropdown } from 'semantic-ui-react'

const preparePersonSelection = (user, companyId) => {
    const { uuid, name, companies } = user;
    const personOptions = [];
    const selectedCompany = companies.filter( company => company.companyId === companyId );
    selectedCompany[0].records.map( record => personOptions.push({ text: record.name, value: record.uuid }))
    return personOptions;
}

const EcardPersonFilter = (props) => {
    const personOptions = preparePersonSelection(props.user, props.selectedCompany);
    return (
        <Dropdown
            placeholder='Select Person'
            fluid
            selection
            options={personOptions}
            value={props.selectedPerson}
            onChange={(e, { value}) => props.updatePersonSelected(value)}
        />
    );
}

export default EcardPersonFilter;
